import { getAuthenticationHeaders } from "common/apis/APIUtility";
import { Storage } from "aws-amplify";
import elcos from "common/apis/ElcosAPI";

const ConfigService = {
  uploadRawFiles: async (configName, files) => {
    const folder = `tmp/configs/${configName}`;
    let fileCounter = 0;
    for (const file of Object.values(files)) {
      await Storage.put(`${folder}/0${fileCounter}_${file.name}`, file, { contentType: file.type });
      fileCounter++;
    }
  },
  parseRawFiles: async (configName, validateOnly = false) => {
    const config = await getAuthenticationHeaders();
    const path = `public/tmp/configs/${configName}/`;
    const body = { path, validateOnly };
    return await elcos.post("/configurations", body, config);
  },
  getAll: async (mode) => {
    const config = await getAuthenticationHeaders();
    return await elcos.get(`/configurations?mode=${mode}`, config);
  },
  getById: async (id) => {
    const config = await getAuthenticationHeaders();
    return await elcos.get(`/configurations/${id}`, config);
  },
  getSourceZipUrlById: async (id) => {
    const config = await getAuthenticationHeaders();
    return await elcos.get(`/configurations/${id}/source-zip`, config);
  },
  deleteById: async (id) => {
    const config = await getAuthenticationHeaders();
    return await elcos.delete(`/configurations/${id}`, config);
  }
};

export default ConfigService